import { SortOrderEnum, useGetAppointmentsQuery } from '@pm/graphql';
import { sub } from 'date-fns';
import { useMemo } from 'react';

export const useGetUpcomingAppointments = () => {
  const scheduledAfter = useMemo(() => {
    const date = sub(new Date(), { hours: 1 });
    date.setMilliseconds(0);
    return date.toISOString();
  }, []);

  const { data, loading, refetch, error } = useGetAppointmentsQuery({
    variables: {
      scheduledAfter,
      orderBy: {
        scheduledAt: SortOrderEnum.Asc,
      },
    },
  });

  return {
    nextUpcomingAppointment: data?.appointments?.edges?.[0]?.node,
    upcomingAppointments:
      data?.appointments?.edges?.map((edge) => edge.node) || [],
    loading,
    error,
    refetch,
  };
};
